import styled from 'styled-components';

export function SmbgRows(props) {
  const { totalRecordCount, daysWithTest, testsPerDay, lastTestDate } = props;
  const data = [
    {
      label: 'Total number of tests:',
      value: totalRecordCount ? totalRecordCount : '_'
    },
    { label: 'Days with test:', value: daysWithTest ? daysWithTest : '_' },
    {
      label: 'Tests per day:',
      value: testsPerDay ? Math.round(testsPerDay * 10) / 10 : '_'
    },
    { label: 'Last test’s date:', value: lastTestDate ? lastTestDate : '_' }
  ];

  return (
    <StyledSmbg>
      {data.map(({ label, value }) => (
        <div className="smbg-row" key={label}>
          <span className="smbg-value">{value}</span>
          <span className="smbg-label">{label}</span>
        </div>
      ))}
    </StyledSmbg>
  );
}

const StyledSmbg = styled.div`
  padding: 24px 20px;
  width: 100%;
  .smbg-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .smbg-label {
    direction: ltr;
    color: #4e4e4e;
    font-size: 14px;
  }
  .smbg-value {
    color: #753cbe;
    font-size: 18px;
    font-family: 'dana-bold';
  }
  @media screen and (min-width: 1024px) {
    padding: 0;
    .smbg-row {
      padding-bottom: 7px;
      border-bottom: 1px solid #ebebeb;
    }
    .smbg-label {
      font-size: 24px;
      color: #1f2937;
    }
    .smbg-value {
      font-size: 24px;
    }
    div:nth-last-child(1) {
      border: none;
    }
  }
`;
